import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { CrudService } from './crud.service';
import { Startups } from '../models/startups';

@Injectable({
  providedIn: 'root'
})

export class EmailService extends CrudService<any, number> {

  constructor(protected override _http: HttpClient) {
    super(_http, `${environment.baseUrl}/email`);
  }

 


}



